export function findAndIdentify(condition) {
  return (orderedReservations, controlServerIdentifiers) => {
    const f = orderedReservations.find(condition);
    if (f) {
      f.controlServer.identifier = controlServerIdentifiers[f.controlServer.id];
    }
    return f;
  };
}
